import { BuildType } from './ApiService';

export const configService = (build: BuildType) => ({
    getPublicConfigs: build.query<{ [key: string]: string }, void>({
        query: () => ({
            url: 'config/public',
            method: 'GET',
        }),
    }),
    getPartnerLandingBrandingConfig: build.query<unknown, void>({
        query: () => ({
            url: 'config/public/partner-landing-branding',
            method: 'GET',
        }),
    }),
});
